/* Editable Shopify question graph. Results always render real products/collections. */
(() => {
  'use strict';
  const instances = new Map();
  function init(scope = document) {
    const roots = [...(scope.matches?.('[data-quiz-flow]') ? [scope] : []), ...scope.querySelectorAll('[data-quiz-flow]')];
    for (const root of roots) {
      if (instances.has(root)) continue;
      const controller = new AbortController(), { signal } = controller;
      const panels = new Map([...root.querySelectorAll('[data-flow-question]')].map(e => [e.dataset.flowQuestion, e]));
      const answers = new Map([...root.querySelectorAll('[data-flow-answer]')].map(e => [e.value, e]));
      const results = root.querySelector('[data-flow-results]'), questions = root.querySelector('[data-flow-questions]');
      const error = root.querySelector('[data-flow-error]'), bar = root.querySelector('[data-flow-progress]');
      const history = [], remembered = new Map();
      let current = 'start', mode = 'question', pending = 0;
      const depth = (key, seen = new Set()) => {
        if (!panels.has(key) || seen.has(key)) return 1;
        const branch = new Set(seen); branch.add(key);
        return 1 + Math.max(1, ...[...panels.get(key).querySelectorAll('[data-flow-answer]')].map(input => input.dataset.next ? depth(input.dataset.next, branch) : 1));
      };
      const update = () => {
        const total = mode === 'result' ? history.length + 1 : history.length + depth(current);
        const step = mode === 'result' ? total : history.length + 1;
        const percent = Math.round(step / total * 100);
        bar.setAttribute('aria-valuenow', String(percent)); bar.querySelector('i').style.width = percent + '%';
        root.querySelector('[data-flow-step]').textContent = root.dataset.stepLabel.replaceAll('[current]', step).replaceAll('[total]', total);
        root.querySelector('.loop-flow-navigation [data-flow-back]').hidden = !history.length;
        root.querySelector('.loop-flow-navigation [data-flow-reset]').hidden = !history.length;
      };
      const showQuestion = (key, focus = true) => {
        current = key; mode = 'question'; questions.hidden = false; results.hidden = true; error.hidden = true;
        panels.forEach((panel, node) => { panel.hidden = node !== key; }); update();
        if (focus) panels.get(key)?.querySelector('h1,h2')?.focus({ preventScroll: false });
      };
      const fail = (message) => { error.textContent = message; error.hidden = false; };
      const advance = () => {
        if (mode !== 'question') return;
        const input = panels.get(current)?.querySelector('[data-flow-answer]:checked');
        if (!input) { fail(error.dataset.required); return; }
        const next = input.dataset.next;
        if (next && (!panels.has(next) || next === current || history.some(item => item.key === next))) { fail(error.dataset.unavailable); return; }
        const old = remembered.get(current);
        if (old && old !== input.value) {
          const keep = new Set([...history.map(item => item.key), current]);
          panels.forEach((panel, key) => { if (!keep.has(key)) panel.querySelectorAll('input').forEach(e => { e.checked = false; }); });
        }
        remembered.set(current, input.value); history.push({ key: current, answer: input.value });
        if (next) { showQuestion(next); return; }
        let result = root.querySelector(`[data-flow-result="${CSS.escape(input.value)}"]`);
        if (result?.dataset.hasRecommendation !== 'true') {
          result = [...history].reverse().map(item => root.querySelector(`[data-flow-result="${CSS.escape(item.answer)}"]`)).find(e => e?.dataset.hasRecommendation === 'true') || result;
        }
        root.querySelectorAll('[data-flow-result]').forEach(e => { e.hidden = e !== result; });
        mode = 'result'; questions.hidden = true; results.hidden = false; update();
        root.querySelector('[data-flow-result-heading]').focus();
      };
      const schedule = input => {
        clearTimeout(pending);
        pending = setTimeout(() => { if (mode === 'question' && current === input.dataset.question && input.checked) advance(); }, 0);
      };
      root.querySelectorAll('[data-flow-next]').forEach(button => button.addEventListener('click', advance, { signal }));
      for (const input of answers.values()) {
        input.addEventListener('change', () => { if (root.dataset.autoAdvance === 'true') schedule(input); }, { signal });
        input.closest('label').addEventListener('click', () => { if (root.dataset.autoAdvance === 'true') schedule(input); }, { signal });
      }
      root.querySelectorAll('[data-flow-back]').forEach(button => button.addEventListener('click', () => {
        clearTimeout(pending); const previous = history.pop(); if (previous) showQuestion(previous.key);
      }, { signal }));
      root.querySelectorAll('[data-flow-reset]').forEach(button => button.addEventListener('click', () => {
        clearTimeout(pending); history.length = 0; remembered.clear(); answers.forEach(input => { input.checked = false; }); showQuestion('start');
      }, { signal }));
      root.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('[data-flow-question]');
        if (block && root.contains(block)) { history.length = 0; showQuestion(block.dataset.flowQuestion, false); }
      }, { signal });
      showQuestion('start', false);
      instances.set(root, () => { clearTimeout(pending); controller.abort(); instances.delete(root); });
    }
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, destroy] of instances) if (root === event.target || event.target.contains(root)) destroy(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
